// import * as firebase from 'firebase'
// import 'firebase/auth'
import { AngularFireAuth } from '@angular/fire/compat/auth'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import { Observable, throwError, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../auth/user';
import { switchMap } from 'rxjs/operators';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { NotificationService } from '../shared/notification.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
@Injectable({ providedIn: 'root' })export class AuthService {
  user$: Observable<User>
  token: string;
  companyId;
  _user;

  constructor(private firebaseAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router,
    private notifierService: NotificationService,
    private http: HttpClient) {
    // this.user = firebaseAuth.authState;
    this.assingUser();

    this.firebaseAuth.authState.subscribe(user => {
      if(!user){
        router.navigate(['/signin'])
      }
    });
  }

  assingUser() {
    this.user$ = this.firebaseAuth.authState.pipe(
      switchMap(user => {
        if (user) {

          return this.afs.doc<User>(`users/${user.uid}`).valueChanges()
        } else {
          return null
        }
      }))
  }

  // singupUser(email: string, password: string) {
  //   return this.firebaseAuth.auth.createUserWithEmailAndPassword(email, password)
  // }

  signinUser(email: string, password: string, skipNavigation: boolean = false) {
    return new Promise(async (res, rej) => {
      try {
        let response = await this.firebaseAuth.signInWithEmailAndPassword(email, password)

       console.log("User",response.user)

        this.afs.collection('users').doc<User>(`${response.user.uid}`).get().subscribe(async (doc) => {
          // console.log(doc.data())
          this._user = doc.data();

          this.afs.doc<User>(`users/${response.user.uid}`).update({ signedIn: moment().unix() })
          // console.log("ddd",doc.data())
          if (doc.data().companyId) {

            this.companyId = doc.data().companyId;

            localStorage.setItem('companyId', JSON.stringify(doc.data().companyId));

            let token = await (await this.firebaseAuth.currentUser).getIdToken()

            localStorage.setItem('token', token);

            this.token = token;
            
            res(response);
            
            // Only navigate if not skipping navigation
            if (!skipNavigation) {
              if (doc.data().companyId.length == 1) {
                if (doc.data()['sites'].length == 1) {
                  // console.log("specific site", doc.data()['sites'][0])
                  this.router.navigate(['/dashboard/sites/' + doc.data()['sites'][0]])
                } else {
                  // console.log("all site")

                  this.router.navigate(['/dashboard/sites'])
                }
              } else {
                // console.log("more generic site")
                this.router.navigate(['/dashboard/sites'])
              }
            }
          } else {
            rej({ message: "No company assingned. Please contact with IT department." });
            console.log("Please contact with IT department.")
            // this.erro("Please contact with IT department for this issue.")
          }
        }, err => console.error('oops, an error!', err))

      } catch (err) {
        console.log("ERROR", err)

        if (err.code === 'auth/user-disabled') {
          rej({ message: "This account has been deactivated. Contact a super-admin to reactivate it." });
          return;
        }

        // Check if it's a wrong password or user not found error
        if (err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found') {
          try {
            // Check what providers are available for this email
            const userCheck = await this.checkUserByEmail(email);
            
            if (userCheck.exists && !userCheck.hasEmailPassword) {
              // User exists but doesn't have password, only social providers
              const availableProviders = userCheck.providers;
              let providerMessage = "";
              
              if (availableProviders.includes('google.com') && availableProviders.includes('microsoft.com')) {
                providerMessage = "Your account is now linked to Google and Microsoft. Please access your account from there.";
              } else if (availableProviders.includes('google.com')) {
                providerMessage = "Your account is now linked to Google. Please use the 'Sign in with Google' button to log in.";
              } else if (availableProviders.includes('microsoft.com')) {
                providerMessage = "Your account is now linked to Microsoft. Please use the 'Sign in with Microsoft' button to log in.";
              } else {
                providerMessage = "Your account is now linked to a social provider. Please use the appropriate social login button to access your account.";
              }
              
              rej({ 
                message: providerMessage,
                code: "use-social-provider",
                availableProviders: availableProviders
              });
              return;
            }
          } catch (checkError) {
            console.log('Error checking user providers:', checkError);
            // Continue with original error if check fails
          }
        }
        
        rej(err);
        // throw err
      }
    })

  }

  signInWithGoogle() {
    return new Promise(async (res, rej) => {
      try {
        const provider = new firebase.auth.GoogleAuthProvider();
        provider.setCustomParameters({ prompt: 'select_account' });
        const result = await this.firebaseAuth.signInWithPopup(provider);
        
        console.log("Google User", result.user);
        console.log('Google sign-in email:', result.user.email);
        console.log('Google sign-in providerData:', result.user.providerData);
        // Use providerData for robust provider check
        const providerIds = result.user.providerData.map(p => p.providerId);
        const hasGoogle = providerIds.includes('google.com');
        const hasPassword = providerIds.includes('password');
        // Block only if user has password but NOT google linked
        if (hasPassword && !hasGoogle) {
          await this.logout();
          rej({ 
            message: "Please log in with email and password, then link your Google account from the dashboard.",
            code: "use-email-password-and-link",
            existingProvider: "password"
          });
          return;
        }
        this.afs.collection('users').doc<User>(`${result.user.uid}`).get().subscribe(async (doc) => {
          this._user = doc.data();
          try {
            await this.afs.doc<User>(`users/${result.user.uid}`).update({ signedIn: moment().unix() });
          } catch (updateErr) {
            // Firestore update error (user doc not found)
            await this.logout();
            rej({ message: "No company assingned. Please contact with IT department." });
            return;
          }
          if (doc.data() && doc.data().companyId) {
            this.companyId = doc.data().companyId;
            localStorage.setItem('companyId', JSON.stringify(doc.data().companyId));
            let token = await (await this.firebaseAuth.currentUser).getIdToken();
            localStorage.setItem('token', token);
            this.token = token;
            if (doc.data().companyId.length == 1) {
              if (doc.data()['sites'].length == 1) {
                this.router.navigate(['/dashboard/sites/' + doc.data()['sites'][0]]);
              } else {
                this.router.navigate(['/dashboard/sites']);
              }
            } else {
              this.router.navigate(['/dashboard/sites']);
            }
          } else {
            // If rejected, clear session so user can try another account
            await this.logout();
            rej({ message: "No company assingned. Please contact with IT department." });
          }
        }, err => {
          // Firestore get error
          this.logout();
          rej({ message: "No company assingned. Please contact with IT departments." });
        });
      } catch (err) {
        console.log("ERROR", err);

        if (err.code === 'auth/user-disabled') {
          rej({ message: "This account has been deactivated. Contact a super-admin to reactivate it." });
          return;
        }

        // Handle Firebase's built-in account exists error
        if (err.code === 'auth/account-exists-with-different-credential') {
          await this.logout();
          rej({ 
            message: "You already have an account with email and password. Please use the email/password login option.",
            code: "account-exists-with-different-credential",
            existingProvider: "password"
          });
          return;
        }
        
        rej({ message: "No company assingned. Please contact with IT department." });
      }
    });
  }

  signInWithMicrosoft() {
    return new Promise(async (res, rej) => {
      try {
        const provider = new firebase.auth.OAuthProvider('microsoft.com');
        const result = await this.firebaseAuth.signInWithPopup(provider);
        console.log("Microsoft User", result.user);
        console.log('Microsoft sign-in email:', result.user.email);
        console.log('Microsoft sign-in providerData:', result.user.providerData);
        
        // Use providerData for robust provider check
        const providerIds = result.user.providerData.map(p => p.providerId);
        const hasMicrosoft = providerIds.includes('microsoft.com');
        const hasPassword = providerIds.includes('password');
        
        // Block only if user has password but NOT Microsoft linked
        if (hasPassword && !hasMicrosoft) {
          await this.logout();
          rej({ 
            message: "Please log in with email and password, then link your Microsoft account from the dashboard.",
            code: "use-email-password-and-link",
            existingProvider: "password"
          });
          return;
        }
        
        this.afs.collection('users').doc<User>(`${result.user.uid}`).get().subscribe(async (doc) => {
          this._user = doc.data();
          try {
            await this.afs.doc<User>(`users/${result.user.uid}`).update({ signedIn: moment().unix() });
          } catch (updateErr) {
            // Firestore update error (user doc not found)
            await this.logout();
            rej({ message: "No company assingned. Please contact with IT department." });
            return;
          }
          if (doc.data() && doc.data().companyId) {
            this.companyId = doc.data().companyId;
            localStorage.setItem('companyId', JSON.stringify(doc.data().companyId));
            let token = await (await this.firebaseAuth.currentUser).getIdToken();
            localStorage.setItem('token', token);
            this.token = token;
            if (doc.data().companyId.length == 1) {
              if (doc.data()['sites'].length == 1) {
                this.router.navigate(['/dashboard/sites/' + doc.data()['sites'][0]]);
              } else {
                this.router.navigate(['/dashboard/sites']);
              }
            } else {
              this.router.navigate(['/dashboard/sites']);
            }
          } else {
            // If rejected, clear session so user can try another account
            await this.logout();
            rej({ message: "No company assingned. Please contact with IT department." });
          }
        }, err => {
          // Firestore get error
          this.logout();
          rej({ message: "No company assingned. Please contact with IT department." });
        });
      } catch (err) {
        console.log("ERROR", err);

        if (err.code === 'auth/user-disabled') {
          rej({ message: "This account has been deactivated. Contact a super-admin to reactivate it." });
          return;
        }

        // Handle Firebase's built-in account exists error
        if (err.code === 'auth/account-exists-with-different-credential') {
          await this.logout();
          rej({ 
            message: "You already have an account with email and password. Please use the email/password login option.",
            code: "account-exists-with-different-credential",
            existingProvider: "password"
          });
          return;
        }
        
        rej({ message: "No company assingned. Please contact with IT department." });
      }
    });
  }

  getToken() {
    return new Promise((res, rej) => {
      this.firebaseAuth.currentUser.then(user => {
        if (user) {
          user.getIdToken().then(token => {
            this.token = token;
            res(token);
          }).catch(err => rej(err));
        } else {
          rej('No user logged in');
        }
      }).catch(err => rej(err));
    })
  }

  async resetPassword(email: string) {
    // Firebase Auth refuses to email a disabled account. Admins who need
    // "forgot password" are often exactly the ones the inactivity job just
    // disabled, so re-activate accounts that were auto-disabled for
    // inactivity before asking Firebase to send the reset email. Accounts a
    // super-admin disabled on purpose are left disabled.
    try {
      await this.http.post(
        environment.apiUrl + '/widgets/adminUsers/reactivateForPasswordReset',
        JSON.stringify({ email }),
        { headers: { 'Content-Type': 'application/json' } }
      ).toPromise();
    } catch (err) {
      console.log('reactivateForPasswordReset error', err);
      // Don't block the reset attempt if this check itself fails.
    }

    try {
      return await this.firebaseAuth.sendPasswordResetEmail(email);
    } catch (err) {
      if (err.code === 'auth/user-disabled') {
        throw { message: 'This account has been deactivated. Contact a super-admin to reactivate it.' };
      }
      throw err;
    }
  }



  getCompanyId() {
    return localStorage.getItem('companyId')
  }

  getUser$() {
    return this.user$
  }

  getUserPromise(): Promise<User> {
    return new Promise((res, rej) => {
      const userSub = this.getUser$().subscribe(user => {
        userSub.unsubscribe();
        res(user)
      })
    })
  }

  getUser() {
    return new Promise((res, rej) => {
      if (this._user)
        res(this._user)
      else
        res(false)
    })
  }

  async logout() {
    await this.firebaseAuth.signOut();
    localStorage.removeItem('token');
    localStorage.removeItem('companyId');
    // Force Google session logout
    const googleLogoutUrl = 'https://accounts.google.com/Logout';
    window.open(googleLogoutUrl, '_blank', 'width=500,height=600');
  }

  isAuthenticated() {
    return localStorage.getItem('token')
  }

  private updateUserData(user) {
    // Sets user data to firestore on login
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const data = {
      uid: user.uid,
      email: user.email,
      roles: {
        subscriber: true
      },
      level: null
    }
    return userRef.set(data, { merge: true })

  }

  ///// Role-based Authorization //////

  // Check if user with email exists and what providers they use
  checkUserByEmail(email: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        // Check if email is defined before making the API call
        if (!email) {
          reject({ message: "Email is required" });
          return;
        }
        
        const signInMethods = await firebase.auth().fetchSignInMethodsForEmail(email);
        resolve({
          exists: signInMethods.length > 0,
          providers: signInMethods,
          hasEmailPassword: signInMethods.includes('password')
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  // Link Google account to current user
  linkGoogleAccount(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const provider = new firebase.auth.GoogleAuthProvider();
        const user = await this.firebaseAuth.currentUser;
        if (user) {
          const result = await user.linkWithPopup(provider);
          resolve(result);
        } else {
          reject({ message: "No user is currently signed in" });
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  // Link Microsoft account to current user
  linkMicrosoftAccount(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const provider = new firebase.auth.OAuthProvider('microsoft.com');
        const user = await this.firebaseAuth.currentUser;
        if (user) {
          const result = await user.linkWithPopup(provider);
          resolve(result);
        } else {
          reject({ message: "No user is currently signed in" });
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  // Navigate to dashboard based on user's company and sites
  navigateToDashboard() {
    if (this._user && this._user.companyId) {
      if (this._user.companyId.length == 1) {
        if (this._user['sites'].length == 1) {
          this.router.navigate(['/dashboard/sites/' + this._user['sites'][0]]);
        } else {
          this.router.navigate(['/dashboard/sites']);
        }
      } else {
        this.router.navigate(['/dashboard/sites']);
      }
    }
  }

  canRead(user: User): boolean {
    const allowed = ['admin', 'editor', 'subscriber'];

    return this.checkAuthorization(user, allowed)
  }

  canEdit(user: User): boolean {
    const allowed = ['admin', 'editor']

    return this.checkAuthorization(user, allowed)
  }

  // The PowerOffice log is internal (developer) tooling, hidden from the
  // client's super admins.
  async canSeePowerOfficeLog(): Promise<boolean> {
    const user = await this.firebaseAuth.currentUser;
    return (user?.email || '').toLowerCase() === 'daniyal@squares.no';
  }

  isSuperAdmin(user: User) {
    if (user)
      return user['isSuperAdmin'] == true
    else
      return false
  }

  // `driverManager` is a custom claim set server-side (PUT /driverAdmin/managers/:uid);
  // it is deliberately not a field on the client-writable user doc. It reaches
  // the browser with the ID token, so a newly granted manager needs to sign in
  // again (or refresh their token) before it shows.
  async isDriverManager(): Promise<boolean> {
    try {
      const user = await this.firebaseAuth.currentUser;
      if (!user) return false;
      const result = await user.getIdTokenResult();
      return result.claims['driverManager'] === true;
    } catch (err) {
      return false;
    }
  }

  canPerformActions(user: User): boolean {
    if (user)
      return user['actions'] == true
    else
      return false
  }

  canDelete(user: User): boolean {
    const allowed = ['admin']

    return this.checkAuthorization(user, allowed)
  }

  canAccessSite(siteId) {
    return new Promise((res, rej) => {
      let check;
      let sub: Subscription;
      if (sub)
        sub.unsubscribe()
      sub = this.user$.subscribe(arr => {
        check = arr['sites'].includes(siteId)
        res(check);
      });


    })
  }


  // determines if user has matching role
  private checkAuthorization(user: User, allowedRoles: string[]): boolean {
    if (!user) return false
    for (const role of allowedRoles) {
      if (user.roles[role]) {
        return true
      }
    }
    return false
  }
}